<template>
    <div :class="['c-checkbox',{'disabled': dataDisabled},{'focus': focus}]" @click="click($event)" >
        <div
                id="c-checkbox"
                :class="[{'active':checked},{'small': small},{'navbar': navbar && !small},{'light': light}, {'no-gap': noGap}]">{{label}}<slot></slot></div>
    </div>
</template>

<script>

    export default {
        name: "checkbox",
        data() {
            return {
                checked: false,
                dataDisabled: false,
                focus:false
            }
        },
        props: {
            value: {
                type: [Boolean,Array,String],
                default: false
            },
            label: {
                type: String,
                default: ""
            },
            disabled: {
                type: Boolean,
                default: false
            },
            small: {
                type: Boolean,
                default: false
            },
            navbar: {
              type: Boolean,
              default: false
            },
            light: {
                type: Boolean,
                default: false
            },
            parentFocus: {
                type:Boolean,
                default: false
            },
            noGap: {
                type:Boolean,
                default: false
            }
        },
        created() {
            addEventListener("keydown", this.keydown)
        },
        mounted() {
            this.checked = this.value
            this.dataDisabled = this.disabled
        },
        methods: {
            click() {
                if (!this.dataDisabled) {
                    this.checked = !this.checked
                    this.$emit("change", this.checked)
                }
            },
            keydown(e){
                if (e.keyCode===13 && this.focus)
                {
                    this.checked=!this.checked;
                }
            }
        },
        watch: {
            checked(val) {
                this.$emit("input", val)
            },
            value(val) {
                this.checked = val
            },
            disabled(val) {
                this.dataDisabled = val
            },
            parentFocus(val) {
                this.focus=val;
            }
        },
        beforeDestroy() {
            removeEventListener("keydown", this.keydown)
        }
    }
</script>

<style scoped>
    .c-checkbox {
        display: flex;
    }
    .c-checkbox.focus{
        outline: #1D1D1D;
    }
    .c-checkbox #c-checkbox {
        position: relative;
        display: inline-grid;
        align-items: center;
        grid-template-columns: auto 1fr;
        grid-gap: 12px;
        font-weight: 500;
        font-size: 16px;
        color: var(--dark-1-color);
        margin: 0;
        cursor: pointer;
    }
    .c-checkbox .no-gap#c-checkbox {
        grid-gap: 0;
    }
    .c-checkbox .small#c-checkbox,
    .c-checkbox .navbar#c-checkbox {
        font-size: 12px;
    }
    .c-checkbox .light#c-checkbox {
        color: var(--white-color);
    }
    .c-checkbox.disabled #c-checkbox {
        color: #1d1d1d;
        opacity: .5;
        cursor: default;
    }
    .c-checkbox #c-checkbox::before {
        content: "";
        width: 20px;
        height: 20px;
        border: 2px solid var(--lighten-7-color);
        box-sizing: border-box;
        border-radius: 2px;
        transition: all .2s;
    }
    .c-checkbox .light#c-checkbox::before {
        border: 2px solid var(--white-color);
    }
    .c-checkbox .small#c-checkbox::before,
    .c-checkbox .navbar#c-checkbox::before {
        width: 16px;
        height: 16px;
    }
    .c-checkbox.disabled #c-checkbox::before {
        border: 2px solid var(--lighten-4-color);
        background-color: var(--lighten-6-color);
    }
    .c-checkbox #c-checkbox.active::before {
        border: none;
        background-color: var(--primary-color);
    }
    .c-checkbox .light#c-checkbox.active::before {
        border: 2px solid var(--white-color);
    }
    .c-checkbox #c-checkbox.active::after {
        content: "";
        position: absolute;
        left: 4px;
        top: calc(50% - 6px);
        width: 12px;
        height: 7px;
        border-left: 2px solid transparent;
        border-bottom: 2px solid transparent;
        transform: rotate(-45deg);
    }
    .c-checkbox .small#c-checkbox.active::after {
        left: 4px;
        top: 5px;
        width: 7px;
        height: 3px;
    }

    .c-checkbox .navbar#c-checkbox.active::after {
      top: calc(50% - 3px);
      width: 7px;
      height: 3px;
    }

    .c-checkbox #c-checkbox.active::after {
        border-color: var(--white-color);
    }
</style>
